import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { ArchiveLocationSectorInput, UnarchiveLocationSectorInput } from '../../api/location-sectors/location-sectors.type';
import { LocationSector } from '../../interfaces/locations-sectors';
import { ARCHIVE_LOCATION_SECTOR_MUTATION, UNARCHIVE_LOCATION_SECTOR_MUTATION } from './location-sectors.query';

@Injectable({
  providedIn: 'root'
})
export class ArchiveLocationSectorApi {
  public constructor(private readonly apollo: Apollo) {}

  public async archive(params: ArchiveLocationSectorInput): Promise<void> {
    await this.apollo.mutate<{ updateLocationSector: LocationSector }>({
      mutation: ARCHIVE_LOCATION_SECTOR_MUTATION,
      variables: { input: params },
    }).toPromise();
  }

  public async unarchive(params: UnarchiveLocationSectorInput): Promise<void> {
    await this.apollo.mutate<{ updateLocationSector: LocationSector }>({
      mutation: UNARCHIVE_LOCATION_SECTOR_MUTATION,
      variables: { input: params },
    }).toPromise();
  }

}
